// extracted by mini-css-extract-plugin
export default {"title":"AdminPage_title__xOoJZ","row-breadcrumb":"AdminPage_row-breadcrumb__ixM8+"};